import { Component, Input } from '@angular/core';
import {
  CadastroContratoDto,
  MaritalStatus,
  MeioPagamento,
  OwnerDto,
  PropertyDto,
  PropertyUsage,
  ReurbModalidade
} from '@usucampeao/lib-reurb-simplificado';
import { NumeroExtensoTipo } from '@usucampeao/utils';

@Component({
  selector: 'usucampeao-reurb-gratuito-v2',
  templateUrl: './reurb-gratuito-v2.component.html',
  styleUrls: ['./reurb-gratuito-v2.component.scss']
})
export class ReurbGratuitoV2Component {
  @Input() cadastro!: CadastroContratoDto;
  @Input() proprietario!: Partial<OwnerDto>;
  @Input() conjuge!: Partial<OwnerDto>;
  @Input() imovel!: Partial<PropertyDto>;
  @Input() isPrint: boolean;

  public get imovelTipo(): typeof PropertyUsage {
    return PropertyUsage;
  }

  public get meioPagamento(): typeof MeioPagamento {
    return MeioPagamento;
  }

  public get numeroExtensoTipo(): typeof NumeroExtensoTipo {
    return NumeroExtensoTipo;
  }

  public get reurbModalidade(): typeof ReurbModalidade {
    return ReurbModalidade;
  }

  public get estadoCivil(): typeof MaritalStatus {
    return MaritalStatus;
  }

  public get isPagamentoAVista(): boolean {
    return this.cadastro.pagamentos.length === 1;
  }
}
